import {
  FETCH_SHARED_RESOURCE_START,
  FETCH_SHARED_RESOURCE_SUCCESS,
  FETCH_SHARED_RESOURCE_FAILED,
  UPDATE_SHARED_RESOURCE_STATUS,
} from 'legacy-src/constants/types';

const initialState = {
  resources: [],
  isFetching: false,
  errorMessage: '',
};

const removeSharedResource = (resources, resourceId) =>
  resources.filter((resource) => resource.id !== resourceId);

const updateSharedResources = (resources, resourceId, watchStatus) =>
  resources.map((resource) => {
    if (resource.id === resourceId && watchStatus === 'STARTED') {
      return {
        ...resource,
        status: watchStatus,
        message: `Continue ${resource.displayName}`,
      };
    }
    return resource;
  });

const sharedResources = (state = initialState, action) => {
  const { type, payload } = action;
  const { resourceId, watchStatus, errorMessage } = payload || {};
  const isComplete = watchStatus === 'COMPLETE';
  const { resources } = state;
  const updatedResources = isComplete
    ? resourceId && removeSharedResource(resources, resourceId)
    : resourceId && updateSharedResources(resources, resourceId, watchStatus);
  switch (type) {
    case FETCH_SHARED_RESOURCE_START:
      return {
        ...state,
        resources: [],
        isFetching: true,
        errorMessage: '',
      };
    case FETCH_SHARED_RESOURCE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        resources: payload,
      };
    case FETCH_SHARED_RESOURCE_FAILED:
      return {
        ...state,
        isFetching: false,
        errorMessage,
      };
    case UPDATE_SHARED_RESOURCE_STATUS:
      return {
        ...state,
        resources: updatedResources,
      };
    default:
      return state;
  }
};

export default sharedResources;
